import css from '@app/_src/layout/MinimalFooter.module.css'
import { INLink } from '@components/INLink'
import { ChatIcon, ContactSupportIcon } from '@internations/ds'
import { contact, supportFAQ } from '@routes/catalog'
import { FC } from 'react'

/**
 * A minimal footer used in registration and subscription layouts.
 */
export const MinimalFooter: FC = () => (
    <div className={css.root} data-testid="minimal-footer">
        <ul>
            <li>
                <strong>Need help?</strong>
            </li>
            <li>
                <ChatIcon />
                <INLink route={contact.params({ intent: 'support' })}>Request support</INLink>
            </li>
            <li>
                <ContactSupportIcon />
                <INLink route={supportFAQ}>FAQ</INLink>
            </li>
        </ul>
    </div>
)
